import { pluralize } from '@travelata-libs/utils';
import { ProductType } from '@/shared/config/pages';
import { PREPAYMENT_DEADLINE_TEXTS } from '../config/texts';
import type { PrepaymentDeadline } from '../model/types';

export function formatPrepaymentDeadline(deadline: PrepaymentDeadline, productType: ProductType | null = null): string {
  const texts = PREPAYMENT_DEADLINE_TEXTS[deadline.kind];
  const suffix = productType === ProductType.HotelOffer ? texts.hotelOfferSuffix : texts.suffix;
  const days = `${deadline.days} ${pluralize(texts.pluralForms, deadline.days, false)}`;

  return `${texts.prefix} ${days} ${suffix}`;
}
